(function () {
  'use strict';

  // Map: substring match in link href OR link text → image URL to show
  var IMAGE_OVERRIDES = [
    {
      match: /Virginia_Woolf|ヴァージニア・ウルフ|virginia[-_]woolf/i,
      src:   'https://cdn.shopify.com/s/files/1/0751/6405/7636/files/IMG_1525.jpg?v=1778754683'
    }
  ];

  var IMG_RE = /\.(jpe?g|png|gif|webp|avif)(\?|#|$)/i;

  function findAnchor(el) {
    while (el && el !== document) {
      if (el.tagName === 'A') return el;
      el = el.parentNode;
    }
    return null;
  }

  function resolveOverride(a) {
    var href = a.getAttribute('href') || '';
    var text = (a.textContent || '').trim();
    for (var i = 0; i < IMAGE_OVERRIDES.length; i++) {
      var rule = IMAGE_OVERRIDES[i];
      if (rule.match.test(href) || rule.match.test(text)) {
        return rule.src;
      }
    }
    return null;
  }

  function isImageLink(a) {
    if (!a) return false;
    if (a.getAttribute('data-overlay-image')) return true;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    return IMG_RE.test(href);
  }

  function getOverlaySrc(a) {
    var override = resolveOverride(a);
    if (override) return override;
    return a.getAttribute('data-overlay-image') || a.href;
  }

  var overlay = null;

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'tp-image-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="tp-image-overlay__stage">' +
        '<div class="tp-image-overlay__inner">' +
          '<img class="tp-image-overlay__img" alt="">' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    // Tap anywhere on the overlay to dismiss
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
    return overlay;
  }

  function open(src) {
    var o = ensureOverlay();
    var img = o.querySelector('.tp-image-overlay__img');
    img.src = src;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        o.classList.add('is-open');
        o.setAttribute('aria-hidden', 'false');
      });
    });
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.button !== undefined && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = findAnchor(e.target);
      if (!a) return;
      var hasOverride = !!resolveOverride(a);
      if (!hasOverride && !isImageLink(a)) return;
      e.preventDefault();
      e.stopPropagation();
      open(getOverlaySrc(a));
    },
    true
  );
})();
